/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeMilestoneDto
 */
export interface InitiativeMilestoneDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeMilestoneDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMilestoneDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMilestoneDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMilestoneDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMilestoneDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeMilestoneDto
     */
    targetDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeMilestoneDto
     */
    actualDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof InitiativeMilestoneDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeMilestoneDto
     */
    positionOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InitiativeMilestoneDto
     */
    boardVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeMilestoneDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeMilestoneDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the InitiativeMilestoneDto interface.
 */
export function instanceOfInitiativeMilestoneDto(value: object): value is InitiativeMilestoneDto {
    return true;
}

export function InitiativeMilestoneDtoFromJSON(json: any): InitiativeMilestoneDto {
    return InitiativeMilestoneDtoFromJSONTyped(json, false);
}

export function InitiativeMilestoneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeMilestoneDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'actualDate': json['actualDate'] == null ? undefined : (new Date(json['actualDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'positionOrder': json['positionOrder'] == null ? undefined : json['positionOrder'],
        'boardVisible': json['boardVisible'] == null ? undefined : json['boardVisible'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function InitiativeMilestoneDtoToJSON(json: any): InitiativeMilestoneDto {
    return InitiativeMilestoneDtoToJSONTyped(json, false);
}

export function InitiativeMilestoneDtoToJSONTyped(value?: InitiativeMilestoneDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'initiativeId': value['initiativeId'],
        'name': value['name'],
        'description': value['description'],
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'actualDate': value['actualDate'] == null ? undefined : ((value['actualDate']).toISOString().substring(0,10)),
        'status': value['status'],
        'positionOrder': value['positionOrder'],
        'boardVisible': value['boardVisible'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

